module.exports = __webpack_public_path__ + "img/logo.4a2b1229.png";